import { render, staticRenderFns } from "./rewardDetail.vue?vue&type=template&id=27c16f49&scoped=true"
import script from "./rewardDetail.vue?vue&type=script&lang=js"
export * from "./rewardDetail.vue?vue&type=script&lang=js"
import style0 from "./rewardDetail.vue?vue&type=style&index=0&id=27c16f49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c16f49",
  null
  
)

export default component.exports